import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { ValuesSection } from '../components/ValuesSection';
import { AboutSection } from '../components/AboutSection';
import { ProgramsSection } from '../components/ProgramsSection';
import { WhySection } from '../components/WhySection';
import { LocalSEOSection } from '../components/LocalSEOSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen bg-white font-sans text-neutral-900 selection:bg-red-100 selection:text-red-900" data-id="element-161">
      <Header data-id="element-162" />
      <div id="accueil" data-id="element-163">
        <Hero data-id="element-164" />
      </div>
      <ValuesSection data-id="element-165" />
      <div id="apropos" data-id="element-166">
        <AboutSection data-id="element-167" />
      </div>
      <div id="programmes" data-id="element-168">
        <ProgramsSection data-id="element-169" />
      </div>
      <WhySection data-id="element-170" />
      <LocalSEOSection data-id="element-171" />
      <div id="contact" data-id="element-172">
        <FinalCTA data-id="element-173" />
      </div>
      <Footer data-id="element-174" />
    </div>;
}